import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import withBaseGameConfiguration from "../../core/components/basegame/configuration/withBaseGameConfiguration";
import UIManager from "../../core/components/ui/UiBuilder";
import { actions as layoutsActions } from "../../core/reducers/layoutsStateReducer";
import { actions as baseGameAction } from "../../core/reducers/baseGameReducer";
import { actions as winCelebrationActions } from "../../gamereducer/winCelebrationReducer";
import { actions as buttonActions } from "../../core/reducers/buttonPanelReducer";
import { actions as freeGameAction } from "../../core/reducers/freeGameReducer";
import PIXI from "pixi.js";
import { isMobile } from "react-device-detect";
import { CURRENCY, TIMER } from "../../core/utills";
import { actions as soundActions } from "../../core/reducers/soundReducer";
import { actions as basegameActions } from "../../core/reducers/baseGameReducer";

import {
    configGame
} from "../../data/config";
import { actions as behaviourAction } from "../../gamereducer/behaviourReducer";
import { actions as winDropActions } from '../../gamereducer/winDropReducer';
import { actions as multiplierActions } from "../../gamereducer/multiplierReducer";
import { actions as giantWildActions } from "../../gamereducer/giantWildReducer";
import { stat } from "fs";
import { actions as keyboardListenerActions } from "../../core/reducers/keyboardListenerReducer";

interface IProps {
    [x: string]: any;
}

interface IStore {
    [x: string]: any;
}

interface IStateToProps {


    layoutMode: string,
    balance: number,
    winAmount: number,
    allSpinComplete: any,
    stopIfSingleWinExceed: any,
    stopIfBalanceIncreasedBy: any,
    stopIfBalanceDecreasedBy: any,
    stopAutoplayOnAnyWin: any,
    basegamestate: any,
    spinStart: any,
    currentBetIndex: any,
    betList: any,
    currentCascadeCount: any,
    totalCascadeCount: any,
    allButtonEnable: any,
    transitionBalance: any,
    previousBalance: any,
    selectedCoin: any,
    coinList: any,
    spinStopID: any,
    displayReelGridSymbolCount: any,
    winAmountEmpty: any,
    InTurboMode: any,
    resetMultiWaysTextToInitial: any,
    totalCreditWinAmount: any,
    featureJustReTriggered: any,
    storeAmountForAutoplay: any,
    blastStart: any,
    storeMultiplierCurrentValue: any,
    startGiantWild: any,
    callFlowManager: any,
    bodyBuilderSelected: any,
    startRandomWild: any,
    showBannerForReconstruction: any,
    soundIsPlaying: any,

}

interface IDispatchToProps {
}

interface IState {
    [x: string]: any;
}

class GameBaseGame extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected gameBaseGameContainer: _ReactPixi.IContainer | Ref<any>;
    protected ui_mode: string;
    protected displayUI: any;
    protected logoAnimIntervalTime: number;
    protected baseGameFrameBorder: any;
    protected baseGameFramesInsidePortionImage: any;
    protected headerMeterImage: any;
    protected leftCaveImage: any;
    protected rightCaveImage: any;
    protected logoForMobile: any;
    protected logoForDesktop: any;
    protected originalScalingOfObject: number = 1;
    protected frameBorderScaling: number = 1.1;
    protected multiwaysTextPortraitScalingX: number = 0.7;
    protected multiwaysTextPortraitScalingY: number = 0.8;
    protected cavePortraitScalingX: number = 0.9;
    protected cavePortraitScalingY: number = 0.89;
    protected storeCurrentBalance: number = 0;
    protected storeTotalWinAmount: number = 0;
    protected constantT1: number = 2000;
    protected constantT2: number = 100;
    protected megaWaysTextValue: number = 1;
    protected winValueStore: number = 0;
    protected baseGameSound: string = "introductionSoundLoop";
    protected reelGridSymbolsArray: any = [];
    protected winCelebration: boolean = true;
    protected megaWaysIntialValue: number = 2880;


    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.state = {
            uiElements: [],
            lang: "en"
        }
        this.gameBaseGameContainer = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";
        }
        this.logoAnimIntervalTime = 11050;
        this.displayUI = this.props.child.filter(this.checkUiMode.bind(this));
    }

    //while first rendering, this method will check the mode first
    checkUiMode(uimodeobj: any) {
        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    //this method will initialize object in a variable
    initializeObjectToVariable() {
        this.baseGameFrameBorder = UIManager.getRef("BG_frame_Image_mobile");
        this.baseGameFramesInsidePortionImage = UIManager.getRef("BG_reelOfFrame_Image_Mobile");
        this.headerMeterImage = UIManager.getRef("header_meter_mobile");
        this.leftCaveImage = UIManager.getRef("leftCaveMaskImage_mobile");
        this.rightCaveImage = UIManager.getRef("rightCaveMaskImage_mobile");
        this.logoForDesktop = UIManager.getRef("BG_gameLogo_Anim_desktop");
        this.logoForMobile = UIManager.getRef("BG_gameLogo_Anim_mobile");
    }


    componentDidMount() {
        this.props.activeMultiplier(true);

        this.props.showBannerForReconstruction ? this.props.setMultiplierValue(this.props.storeMultiplierCurrentValue) : this.props.setMultiplierValue(1);


        if (this.props.basegamestate && this.props.soundIsPlaying) {
            this.props.playingSound(true);
        }
        this.layoutChange(this.props.layoutMode);
        this.initializeObjectToVariable();
        this.bindUI();
        this.setMultiwaysInitially();
        this.onOrientationChange();
        UIManager.getRef("bodyBuilderCharacterBtn_" + this.ui_mode) && (UIManager.getRef("bodyBuilderCharacterBtn_" + this.ui_mode).click = (event: any) => {
            this.handleEvent(UIManager.getRef("bodyBuilderCharacterBtn_" + this.ui_mode));
        })

        UIManager.getRef("skeletonCharacterBtn_" + this.ui_mode) && (UIManager.getRef("skeletonCharacterBtn_" + this.ui_mode).click = (event: any) => {
            this.handleEvent(UIManager.getRef("skeletonCharacterBtn_" + this.ui_mode));
        })

        UIManager.getRef("bodyBuilderCharacterBtn_" + this.ui_mode) && (UIManager.getRef("bodyBuilderCharacterBtn_" + this.ui_mode).touchend = (event: any) => {
            this.handleEvent(UIManager.getRef("bodyBuilderCharacterBtn_" + this.ui_mode));
        })

        UIManager.getRef("skeletonCharacterBtn_" + this.ui_mode) && (UIManager.getRef("skeletonCharacterBtn_" + this.ui_mode).touchend = (event: any) => {
            this.handleEvent(UIManager.getRef("skeletonCharacterBtn_" + this.ui_mode));
        })


        let timer = TIMER.TimerManager.createTimer(500);
        timer.on('end', () => {
            this.props.spaceBarSpin(true);
        });
        timer.start();

        this.setCharacter();
    }
    setCharacter() {

        let skeletonBtn, bodyBuilderBtn;
        if (UIManager.getRef("skeletonCharacterBtn_" + this.ui_mode)) {
            skeletonBtn = UIManager.getRef("skeletonCharacterBtn_" + this.ui_mode);
            bodyBuilderBtn = UIManager.getRef("bodyBuilderCharacterBtn_" + this.ui_mode);
        }

        if (this.props.bodyBuilderSelected) {
            skeletonBtn && (skeletonBtn.visible = true);
            bodyBuilderBtn && (bodyBuilderBtn.visible = false);
            this.changeCharacter("bodyBuilderCharacterIdle_" + this.ui_mode, "skeletonCharacterIdle_" + this.ui_mode);
        }
        else {
            skeletonBtn && (skeletonBtn.visible = false);
            bodyBuilderBtn && (bodyBuilderBtn.visible = true);
            this.changeCharacter("skeletonCharacterIdle_" + this.ui_mode, "bodyBuilderCharacterIdle_" + this.ui_mode);
        }
    }
    setMultiwaysInitially() {
        this.symbolsCountRearrangeCount(this.props);
        let totalMegaWaysCount = 1;
        for (let j = 0; j < this.reelGridSymbolsArray.length; j++) {
            totalMegaWaysCount = totalMegaWaysCount * this.reelGridSymbolsArray[j];
        }
        UIManager.getRef("BG_multiwaysText_desktop") && (UIManager.getRef("BG_multiwaysText_desktop").text = totalMegaWaysCount);
        UIManager.getRef("BG_multiwaysText_mobile") && (UIManager.getRef("BG_multiwaysText_mobile").text = totalMegaWaysCount);
    }
    symbolsCountRearrangeCount(nextProps: any) {

        for (let i = 0; i < nextProps.displayReelGridSymbolCount.length; i++) {
            let data;
            if (i == 0 || i == nextProps.displayReelGridSymbolCount.length - 1) {
                data = nextProps.displayReelGridSymbolCount[i];
            } else if (i > 0) {
                data = nextProps.displayReelGridSymbolCount[i] + 1;
            }

            this.reelGridSymbolsArray.push(data);
        }

    }
    correctCurrencyCodeXAF(amount: string) {
        if ((window as any).GAME_INFO.currency == "XAF") {
            return amount.replace('F', 'FCFA');
        }
        if ((window as any).GAME_INFO.currency == "XOF") {
            return amount.replace('F', 'XOF');
        }
        return amount;
    }

    //this method will call after the first rendering for scaling and logo animation looping
    bindUI() {
        if (isMobile) {
            if (window.innerWidth < window.innerHeight) {
                this.portraitScaling();
            } else {
                this.landscapeScaling();
            }
            this.logoForMobile && (this.logoForMobile.gotoAndPlay(0));

            let balanceValueInCurrency = CURRENCY.CurrencyManager.formatCurrencyString(this.props.balance / this.constantT2, true, true, true, true);
            balanceValueInCurrency = this.correctCurrencyCodeXAF(balanceValueInCurrency);

            let betValueInCurrency = CURRENCY.CurrencyManager.formatCurrencyString(this.props.betList[this.props.currentBetIndex] / this.constantT2, true, true, true, true);
            betValueInCurrency = this.correctCurrencyCodeXAF(betValueInCurrency);
            UIManager.getRef("Mobiletext_balance_value") && (UIManager.setText("Mobiletext_balance_value", balanceValueInCurrency));
            UIManager.getRef("Mobiletext_bet_value") && (UIManager.setText("Mobiletext_bet_value", betValueInCurrency));


        } else {
            this.logoForDesktop && (this.logoForDesktop.gotoAndPlay(0));
            let balance = this.props.balance / this.constantT2;
            UIManager.getRef("text_balance_value") && (UIManager.setText("text_balance_value", Math.round((((balance) / this.props.coinList[this.props.selectedCoin] * this.constantT1)))));

        }

        if (this.logoForMobile || this.logoForDesktop) {
            let timer = TIMER.TimerManager.createTimer(this.logoAnimIntervalTime);
            timer.on('repeat', () => {
                if (isMobile) {
                    this.logoForMobile && (this.logoForMobile.gotoAndPlay(0));
                } else {
                    this.logoForDesktop && (this.logoForDesktop.gotoAndPlay(0));
                }
            });
            timer.start(true, 20);
        }

    }

    //this method will be called when a button gets clicked
    handleEvent(e: any) {
        UIManager.getRef("animChangeEffect_" + this.ui_mode) && (UIManager.getRef("animChangeEffect_" + this.ui_mode).visible = false);
        let skeletonBtn, bodyBuilderBtn;
        skeletonBtn = UIManager.getRef("skeletonCharacterBtn_" + this.ui_mode);
        bodyBuilderBtn = UIManager.getRef("bodyBuilderCharacterBtn_" + this.ui_mode);

        if (e.name === "skeletonCharacterBtn_" + this.ui_mode) {
            skeletonBtn.visible = false;
            bodyBuilderBtn.visible = true;
            this.changeCharacter("skeletonCharacterIdle_" + this.ui_mode, "bodyBuilderCharacterIdle_" + this.ui_mode);
            this.props.changeCharacter(false)
        }
        if (e.name === "bodyBuilderCharacterBtn_" + this.ui_mode) {
            skeletonBtn.visible = true;
            bodyBuilderBtn.visible = false;
            this.changeCharacter("bodyBuilderCharacterIdle_" + this.ui_mode, "skeletonCharacterIdle_" + this.ui_mode);
            this.props.changeCharacter(true)
        }
    }

    changeCharacter(currentCharacter: any, previousCharacter: any) {
        let transitionSpine = UIManager.getRef("animChangeEffect_" + this.ui_mode);
        let btnGlowSpine = UIManager.getRef("btnGlow_" + this.ui_mode);
        transitionSpine && (transitionSpine.visible = true);

        UIManager.getRef("btnGlowContainer" + this.ui_mode) && (UIManager.getRef("btnGlowContainer" + this.ui_mode).visible = true);
        btnGlowSpine && btnGlowSpine.children[0].state.setAnimation(0, "fx_glow_yellow", false);

        transitionSpine && transitionSpine.children[0].state.setAnimation(0, "trans", false);
        // UIManager.getRef("animChangeEffect_desktop") && UIManager.getRef("animChangeEffect_desktop").gotoAndPlay(0);

        let timer = TIMER.TimerManager.createTimer(400);
        timer.on('end', (e: any) => {
            UIManager.getRef(currentCharacter) && (UIManager.getRef(currentCharacter).visible = true);
            UIManager.getRef(previousCharacter) && (UIManager.getRef(previousCharacter).visible = false);
        })
        timer.start();
    }
    //this method will scale reelgrid according to the screen size
    onOrientationChange() {
        let reelGrid = UIManager.getRef("gridLayer");
        if (isMobile && window.innerHeight > window.innerWidth) {
            UIManager.getRef("total_win_text_mobile") && UIManager.getRef("total_win_text_mobile").scale.set(0.95);
            UIManager.getRef("win_panel_mobile") && UIManager.getRef("win_panel_mobile").scale.set(0.92);
            UIManager.getRef("game_logoContainer_mobile") && UIManager.getRef("game_logoContainer_mobile").scale.set(0.37);
            UIManager.getRef("bodyBuilderCharacterIdle_mobile") && UIManager.getRef("bodyBuilderCharacterIdle_mobile").scale.set(0.92);
            UIManager.getRef("skeletonCharacterIdle_mobile") && UIManager.getRef("skeletonCharacterIdle_mobile").scale.set(0.82);
            reelGrid && reelGrid.scale.set(configGame.REEL_GRID_SCALE_IN_PORTRAIT);
            reelGrid && reelGrid.position.set(configGame.REEL_GRID_X_IN_PORTRAIT, configGame.REEL_GRID_Y_IN_PORTRAIT);
        } else {
            UIManager.getRef("total_win_text_mobile") && UIManager.getRef("total_win_text_mobile").scale.set(1);
            UIManager.getRef("win_panel_mobile") && UIManager.getRef("win_panel_mobile").scale.set(1);
            UIManager.getRef("game_logoContainer_mobile") && UIManager.getRef("game_logoContainer_mobile").scale.set(0.55);

            UIManager.getRef("bodyBuilderCharacterIdle_mobile") && UIManager.getRef("bodyBuilderCharacterIdle_mobile").scale.set(1);
            UIManager.getRef("skeletonCharacterIdle_mobile") && UIManager.getRef("skeletonCharacterIdle_mobile").scale.set(1);
            reelGrid && reelGrid.scale.set(configGame.REEL_GRID_SCALE);
            reelGrid && reelGrid.position.set(configGame.REEL_GRID_X, configGame.REEL_GRID_Y);
        }

    }
    characterLayoutChange() {
        if (this.props.bodyBuilderSelected) {
            UIManager.getRef("bodyBuilderCharacterIdle_mobile") && (UIManager.getRef("bodyBuilderCharacterIdle_mobile").visible = true);
            UIManager.getRef("skeletonCharacterIdle_mobile") && (UIManager.getRef("skeletonCharacterIdle_mobile").visible = false);
        } else {
            UIManager.getRef("bodyBuilderCharacterIdle_mobile") && (UIManager.getRef("bodyBuilderCharacterIdle_mobile").visible = false);
            UIManager.getRef("skeletonCharacterIdle_mobile") && (UIManager.getRef("skeletonCharacterIdle_mobile").visible = true);
        }
    }
    //when layout changes, this method will be called
    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        }
        )
        let timer1 = TIMER.TimerManager.createTimer(10);
        timer1.on('end', (e: any) => {
            e.remove();
            this.characterLayoutChange();
        })
        timer1.start();

    }

    //scaling for portrait mode
    portraitScaling() {
        this.baseGameFrameBorder && (this.baseGameFrameBorder.scale.set(this.frameBorderScaling));

        this.headerMeterImage && (this.headerMeterImage.scale.set(this.frameBorderScaling));

    }

    //scaling for landscape mode
    landscapeScaling() {
        this.baseGameFrameBorder && (this.baseGameFrameBorder.scale.set(this.originalScalingOfObject));
        this.headerMeterImage && (this.headerMeterImage.scale.set(this.originalScalingOfObject));
    }
    falseInteractivityOfCharacButton() {
        let skeletonBtn, bodyBuilderBtn;
        skeletonBtn = UIManager.getRef("skeletonCharacterBtn_" + this.ui_mode);
        bodyBuilderBtn = UIManager.getRef("bodyBuilderCharacterBtn_" + this.ui_mode);

        if (this.props.bodyBuilderSelected) {
            skeletonBtn.interactive = false;
            skeletonBtn.buttonMode = false;
        }
        else {
            bodyBuilderBtn.interactive = false;
            bodyBuilderBtn.buttonMode = false;
        }



    }

    trueInteractivityOfCharacButton() {
        let skeletonBtn, bodyBuilderBtn;
        skeletonBtn = UIManager.getRef("skeletonCharacterBtn_" + this.ui_mode);
        bodyBuilderBtn = UIManager.getRef("bodyBuilderCharacterBtn_" + this.ui_mode);
        if (this.props.bodyBuilderSelected) {
            skeletonBtn.interactive = true;
            skeletonBtn.buttonMode = true;
        }
        else {
            bodyBuilderBtn.interactive = true;
            bodyBuilderBtn.buttonMode = true;
        }

    }
    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (nextProps.allButtonEnable !== this.props.allButtonEnable || nextProps.layoutMode !== this.props.layoutMode
            || nextProps.allSpinComplete !== this.props.allSpinComplete || nextProps.spinStart != this.props.spinStart
            || nextProps.winAmount !== this.props.winAmount || nextProps.selectedCoin !== this.props.selectedCoin
            || nextProps.currentBetIndex !== this.props.currentBetIndex || nextProps.spinStopID != this.props.spinStopID
            || nextProps.displayReelGridSymbolCount != this.props.displayReelGridSymbolCount
            || nextProps.winAmountEmpty != this.props.winAmountEmpty || nextProps.basegamestate !== this.props.basegamestate
            || nextProps.blastStart != this.props.blastStart
            || nextProps.startGiantWild != this.props.startGiantWild
            || nextProps.callFlowManager != this.props.callFlowManager
            || nextProps.startRandomWild != this.props.startRandomWild
        ) {

            if ((nextProps.startGiantWild && nextProps.startGiantWild != this.props.startGiantWild) || (nextProps.startRandomWild && nextProps.startRandomWild != this.props.startRandomWild)) {

                this.falseInteractivityOfCharacButton();
            }
            if (nextProps.callFlowManager && nextProps.callFlowManager != this.props.callFlowManager) {

                this.trueInteractivityOfCharacButton();
            }

            if (nextProps.blastStart && nextProps.blastStart != this.props.blastStart) {
                //this.props.setStartWinDrop(true);
                // this.props.setMultiplierValue(nextProps.storeMultiplierCurrentValue);
            }

            if (nextProps.basegamestate) {
                if (this.props.resetMultiWaysTextToInitial) {
                    UIManager.getRef("BG_multiwaysText_desktop") && (UIManager.getRef("BG_multiwaysText_desktop").text = this.megaWaysIntialValue);
                    UIManager.getRef("BG_multiwaysText_mobile") && (UIManager.getRef("BG_multiwaysText_mobile").text = this.megaWaysIntialValue);
                    this.props.resetMultiwaysValue(false);
                }
            }
            if (nextProps.basegamestate && nextProps.basegamestate != this.props.basegamestate) {
                let balanceValueInCurrency = CURRENCY.CurrencyManager.formatCurrencyString(nextProps.transitionBalance / this.constantT2, true, true, true, true);
                balanceValueInCurrency = this.correctCurrencyCodeXAF(balanceValueInCurrency);

                UIManager.getRef("text_balance_value") && (UIManager.setText("text_balance_value", Math.round((((nextProps.transitionBalance / this.constantT2) / this.props.coinList[this.props.selectedCoin] * this.constantT1)))));
                UIManager.getRef("Mobiletext_balance_value") && (UIManager.setText("Mobiletext_balance_value", balanceValueInCurrency));
            }
            if (nextProps.allButtonEnable) {
                let balanceValueInCurrency = CURRENCY.CurrencyManager.formatCurrencyString(nextProps.transitionBalance / this.constantT2, true, true, true, true);
                balanceValueInCurrency = this.correctCurrencyCodeXAF(balanceValueInCurrency);

                UIManager.getRef("text_balance_value") && (UIManager.setText("text_balance_value", Math.round((((nextProps.transitionBalance / this.constantT2) / this.props.coinList[this.props.selectedCoin] * this.constantT1)))));
                UIManager.getRef("Mobiletext_balance_value") && (UIManager.setText("Mobiletext_balance_value", balanceValueInCurrency));
                this.props.setPreviousBalance(nextProps.transitionBalance);
            }
            if (nextProps.selectedCoin !== this.props.selectedCoin) {
                UIManager.getRef("text_balance_value") && (UIManager.setText("text_balance_value", Math.round((((this.props.transitionBalance / this.constantT2) / nextProps.coinList[nextProps.selectedCoin] * this.constantT1)))));

            }
            if (nextProps.winAmountEmpty) {

                UIManager.getRef("text_win_value1") && (UIManager.getRef("text_win_value1").visible = true);
                UIManager.getRef("Mobiletext_win_value") && (UIManager.getRef("Mobiletext_win_value").visible = false);

                // this.props.setWinAmount(false);
            }
            if (nextProps.layoutMode !== this.props.layoutMode) {
                this.layoutChange(nextProps.layoutMode);
                this.onOrientationChange();
                if (isMobile) {
                    if (window.innerWidth < window.innerHeight) {
                        this.portraitScaling();
                    } else {
                        this.landscapeScaling();
                    }

                }
            }

            if (nextProps.allSpinComplete && nextProps.allSpinComplete != this.props.allSpinComplete) {
                setTimeout(() => {
                    this.checkAutoplayConditions(nextProps);

                }, 500)
                if (nextProps.winAmount !== 0) {
                    let timer = TIMER.TimerManager.createTimer(210);
                    timer.on('end', (e: any) => {
                        this.winValueStore = this.winValueStore + this.props.winAmount;
                        //this.reflectWinAmount(nextProps, nextProps.winAmount);
                    })
                    timer.start();
                } else {
                    this.winValueStore = 0;
                }

            }
            if (nextProps.spinStart) {
                if (nextProps.spinStart && nextProps.spinStart != this.props.spinStart) {
                    this.props.storeMultiplierValue(1);
                    this.props.setStartWinDrop(false);
                    if (!nextProps.InTurboMode || !this.props.InTurboMode) {

                    }
                    else {
                        UIManager.getRef("BG_multiwaysText_desktop") && (UIManager.getRef("BG_multiwaysText_desktop").alpha = 0);
                        UIManager.getRef("BG_textMultiWays_Image_Desktop") && (UIManager.getRef("BG_textMultiWays_Image_Desktop").alpha = 0);
                        UIManager.getRef("BG_multiwaysText_mobile") && (UIManager.getRef("BG_multiwaysText_mobile").alpha = 0);
                        UIManager.getRef("BG_textMultiWays_Image_mobile") && (UIManager.getRef("BG_textMultiWays_Image_mobile").alpha = 0);

                    }
                }
                this.winValueStore = 0;
                UIManager.getRef("text_win_value1") && (UIManager.getRef("text_win_value1").visible = true);
                UIManager.getRef("Mobiletext_win_value") && (UIManager.getRef("Mobiletext_win_value").visible = false);
                this.updateValues(nextProps);
            }
            if (nextProps.winAmount !== this.props.winAmount) {
                if (nextProps.winAmount == 0) {
                    UIManager.getRef("text_win_value1") && (UIManager.getRef("text_win_value1").visible = true);
                    UIManager.getRef("Mobiletext_win_value") && (UIManager.getRef("Mobiletext_win_value").visible = false);

                }
                this.winValueStore = nextProps.winAmount + this.winValueStore;
                //this.reflectWinAmount(nextProps, this.winValueStore);
            }
            if (nextProps.currentBetIndex !== this.props.currentBetIndex) {
                UIManager.getRef("Mobiletext_bet_value") && (UIManager.getRef("Mobiletext_bet_value").text = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString((this.props.betList[nextProps.currentBetIndex] / this.constantT2), true, true, true, true)));
            }
            if (nextProps.displayReelGridSymbolCount !== this.props.displayReelGridSymbolCount) {
                this.megaWaysTextValue = 1;
                this.reelGridSymbolsArray = [];
                this.symbolsCountRearrangeCount(nextProps);
                if (nextProps.basegamestate && nextProps.basegamestate != this.props.basegamestate) {
                    this.setMultiwaysInitially();
                }
            }
            if (nextProps.spinStopID > -1) {
                if (!isMobile) {
                    UIManager.getRef("BG_multiwaysText_desktop") && (UIManager.getRef("BG_multiwaysText_desktop").alpha = 1);
                    UIManager.getRef("BG_textMultiWays_Image_Desktop") && (UIManager.getRef("BG_textMultiWays_Image_Desktop").alpha = 1);
                }

                else {
                    UIManager.getRef("BG_multiwaysText_mobile") && (UIManager.getRef("BG_multiwaysText_mobile").alpha = 1);
                    UIManager.getRef("BG_textMultiWays_Image_mobile") && (UIManager.getRef("BG_textMultiWays_Image_mobile").alpha = 1);
                }
                this.megaWaysTextValue = this.megaWaysTextValue * this.reelGridSymbolsArray[nextProps.spinStopID];
                UIManager.getRef("BG_multiwaysText_desktop") && (UIManager.getRef("BG_multiwaysText_desktop").text = this.megaWaysTextValue);
                UIManager.getRef("BG_multiwaysText_mobile") && (UIManager.getRef("BG_multiwaysText_mobile").text = this.megaWaysTextValue);
            }
            return false;
        }
        return false;
    }

    updateValues(nextProps: any) {
        let balanceValueInCurrency = CURRENCY.CurrencyManager.formatCurrencyString((this.props.previousBalance - this.props.betList[this.props.currentBetIndex]) / this.constantT2, true, true, true, true);
        UIManager.getRef("Mobiletext_balance_value") && (UIManager.setText("Mobiletext_balance_value", balanceValueInCurrency));
        UIManager.getRef("text_balance_value") && (UIManager.setText("text_balance_value", Math.round(((this.props.previousBalance - this.props.betList[this.props.currentBetIndex]) / this.constantT2) / this.props.coinList[this.props.selectedCoin] * this.constantT1)));
    }

    reflectWinAmount(nextProps: any, lastWinStore: any) {

    }

    //this method is to check the autoplay condition and to stop it when its required
    checkAutoplayConditions(nextProps: any) {
        let previousAmount = nextProps.transitionBalance - nextProps.totalCreditWinAmount;

        if ((nextProps.balance - nextProps.storeAmountForAutoplay >= this.props.stopIfBalanceIncreasedBy && this.props.stopIfBalanceIncreasedBy !== -1)
            || (nextProps.storeAmountForAutoplay - nextProps.balance >= this.props.stopIfBalanceDecreasedBy && this.props.stopIfBalanceDecreasedBy !== -1)
            || (this.props.totalCreditWinAmount > this.props.stopIfSingleWinExceed && this.props.stopIfSingleWinExceed !== -1)
            || (nextProps.totalCreditWinAmount > 0 && nextProps.stopAutoplayOnAnyWin
                || (nextProps.featureJustReTriggered && nextProps.stopAutoplayOnFreegame)
                || nextProps.featureJustReTriggered && nextProps.stopAutoplayOnAnyWin)) {

            this.props.stopAutoplay();
        }
    }


    render() {
        return (
            <UIManager id={"gameBaseGameContainer"} type={"Container"} ref={i => this.gameBaseGameContainer = i}
                name={"gameBaseGameContainer"}>
                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                            id={i.id} {...i} app={this.app} configGame={configGame}
                            ClickHandler={this.handleEvent.bind(this)} />)
                }
            </UIManager>)
    }

}

export default withPixiApp(connect(
    (state: Pick<IStore, 'soundState' | 'baseGameReconstructionState' | 'randomWildsState' | 'flowManagerState' | 'giantWildState' | 'freegameState' | 'basegameState' | 'applicationState' | 'gridsState' | 'autoplayState' | 'buttonPanelState' | 'behaviourState' | 'betPanelState' | 'MultiplierState'>): IStateToProps =>
    ({
        balance: state.basegameState.balance,
        layoutMode: state.applicationState.layoutMode,
        winAmount: state.basegameState.winAmount,
        basegamestate: state.basegameState.basegamestate,
        allSpinComplete: state.gridsState.allSpinComplete,
        spinStart: state.gridsState.spinStart,
        stopIfSingleWinExceed: state.autoplayState.stopIfSingleWinExceed,
        stopIfBalanceIncreasedBy: state.autoplayState.stopIfBalanceIncreasedBy,
        stopIfBalanceDecreasedBy: state.autoplayState.stopIfBalanceDecreasedBy,
        stopAutoplayOnAnyWin: state.autoplayState.stopAutoplayOnAnyWin,
        currentBetIndex: state.basegameState.currentBetIndex,
        betList: state.basegameState.betList,
        currentCascadeCount: state.gridsState.currentCascadeCount,
        totalCascadeCount: state.gridsState.totalCascadeCount,
        allButtonEnable: state.buttonPanelState.allButtonEnable,
        transitionBalance: state.behaviourState.transitionBalance,
        totalCreditWinAmount: state.behaviourState.totalCreditWinAmount,
        previousBalance: state.behaviourState.previousBalance,
        selectedCoin: state.betPanelState.selectedCoin,
        coinList: state.betPanelState.coinList,
        spinStopID: state.gridsState.spinStopID,
        displayReelGridSymbolCount: state.gridsState.displayReelGridSymbolCount,
        winAmountEmpty: state.behaviourState.winAmountEmpty,
        InTurboMode: state.gridsState.InTurboMode,
        resetMultiWaysTextToInitial: state.behaviourState.resetMultiWaysTextToInitial,
        featureJustReTriggered: state.freegameState.featureJustReTriggered,
        storeAmountForAutoplay: state.behaviourState.storeAmountForAutoplay,
        blastStart: state.gridsState.blastStart,
        storeMultiplierCurrentValue: state.MultiplierState.storeMultiplierCurrentValue,
        startGiantWild: state.giantWildState.startGiantWild,
        callFlowManager: state.flowManagerState.callFlowManager,
        bodyBuilderSelected: state.giantWildState.bodyBuilderSelected,
        startRandomWild: state.randomWildsState.startRandomWild,
        showBannerForReconstruction: state.baseGameReconstructionState.showBannerForReconstruction,
        soundIsPlaying: state.soundState.soundIsPlaying,


    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutsActions.setApplicationLayoutObject(layoutobjectlist)),
        stopAutoplay: (): any => dispatch(baseGameAction.stopAutoplay()),
        winCelebrationStart: (startWinCelebration: boolean, showAmount: string): any => dispatch(winCelebrationActions.winCelebrationStart(startWinCelebration, showAmount)),
        winCelebrationShow: (showWinCelebration: boolean): any => dispatch(winCelebrationActions.winCelebrationShow(showWinCelebration)),
        setAllButtonDisable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonDisable(exceptBtnList)),
        setFeatureJustFinished: (): any => dispatch(freeGameAction.setFeatureJustFinished()),
        playingSound: (soundIsPlaying: any): any => dispatch(soundActions.playingSound(soundIsPlaying)),
        setPreviousBalance: (previousBalance: any): any => dispatch(behaviourAction.setPreviousBalance(previousBalance)),
        setWinAmount: (winAmountEmpty: any): any => dispatch(behaviourAction.setWinAmount(winAmountEmpty)),
        resetMultiwaysValue: (resetMultiWaysTextToInitial: any): any => dispatch(behaviourAction.resetMultiwaysValue(resetMultiWaysTextToInitial)),
        setApplicationToBaseGameState: (basegamestate: boolean): any => dispatch(basegameActions.setApplicationToBaseGameState(basegamestate)),
        setStartWinDrop: (startDrop: number): any => dispatch(winDropActions.setStartWinDrop(startDrop)),
        setMultiplierValue: (multiplierCurrentValue: any): any => dispatch(multiplierActions.setMultiplierValue(multiplierCurrentValue)),
        activeMultiplier: (multiplierActive: boolean): any => dispatch(multiplierActions.activeMultiplier(multiplierActive)),
        storeMultiplierValue: (storeMultiplierCurrentValue: any): any => dispatch(multiplierActions.storeMultiplierValue(storeMultiplierCurrentValue)),
        changeCharacter: (bodyBuilderSelected: any): any => dispatch(giantWildActions.changeCharacter(bodyBuilderSelected)),
        spaceBarSpin: (spinWithSpaceBar: boolean): any => dispatch(keyboardListenerActions.spaceBarSpin(spinWithSpaceBar)),
    }))(withBaseGameConfiguration(GameBaseGame)));